module.exports = __webpack_public_path__ + "static/media/mark_chat_read-black-18dp.1b8fd622.svg";